import React, { useEffect, useState } from 'react';
import { fetchTreatmentPlan, createTreatmentPlan, deleteTreatmentPlan } from '../../api/treatmentsAPI';
import { Button, Form, Card, Row, Col } from 'react-bootstrap'; // For React Bootstrap
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';

export const _baseURL = process.env.REACT_APP_IMG_URL;

const TreatmentPlan = () => {
    const [treatments, settreatments] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true); 

    useEffect(() => {
        const gettreatments = async () => {
            try {
                setLoading(true); 
                const data = await fetchTreatmentPlan();
                settreatments(data);
            } catch (error) {
                setError('Failed to fetch treatments');
            } finally {
                setLoading(false); 
            }
        };

        gettreatments();
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
            setSelectedFile(file);
            setError(null); 
        } else {
            setError('Only JPEG and PNG files are accepted.');
        }
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        if (!selectedFile) return;

        const formData = new FormData();
        formData.append('image', selectedFile);

        try {
            await createTreatmentPlan(formData);
            setSelectedFile(null);
            toast.success("treatments created successfully");
            
            setLoading(true); 
            const data = await fetchTreatmentPlan();
            settreatments(data);
        } catch (error) {
            toast.error("Failed to upload treatments");
            setError('Failed to upload treatments');
        } finally {
            setLoading(false); 
        }
    };

    const handleDelete = async (id) => {
        try {
            await deleteTreatmentPlan(id);
            toast.success("treatments deleted successfully");

            setLoading(true); 
            const data = await fetchTreatmentPlan();
            settreatments(data);
        } catch (error) {
            toast.error("Failed to delete treatments");
            setError('Failed to delete treatments');
        } finally {
            setLoading(false); 
        }
    };

    return (
        <div>
            <h1>Diseases Treated</h1>
            {error && <div className="alert alert-danger">{error}</div>}
            <Form onSubmit={handleUpload}>
                <Form.Group>
                    <Form.Label>Upload Diseases Treated Image</Form.Label>
                    <Form.Control
                        type="file"
                        accept=".jpeg,.jpg,.png"
                        onChange={handleFileChange}
                    />
                </Form.Group>
                <Button type="submit" className='mt-3'>Upload</Button>
            </Form>

            {/* Loader */}
            {loading ? (
                <div className="text-center mt-4">
                   <Loader/>
                </div>
            ) : (
                <Row className="mt-4">
                    {treatments.map((banner) => (
                        <Col lg={3} md={4} sm={6} key={banner._id} className="mb-4">
                            <Card style={{ width: '100%', height: '300px', display: 'flex', flexDirection: 'column' }}>
                                <Card.Img
                                    variant="top"
                                    src={`${_baseURL}upload/${banner.image.data}`}
                                    alt={`Banner ${banner._id}`}
                                    style={{ height: '200px', objectFit: 'cover' }} 
                                />
                                <Card.Body className="d-flex flex-column">
                                    <Button
                                        style={{
                                            backgroundColor:"#d32f2f"
                                        }}
                                        onClick={() => handleDelete(banner._id)}
                                        className="mt-auto" 
                                    >
                                        DELETE
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </div>
    );
};

export default TreatmentPlan;
